<template>
  <div id="zt8629">
    <div :id="$store.state.iscn?'z1':'z1_en'">
      <span v-if="$store.state.iscn">
        <div>ZT8629</div>
        <label>双屏刷脸终端</label>
        <img :src="require('@/assets/pic/zt8629/bg1icon.png')"/>
      </span>
      <span v-else>
        <div>ZT8629 Facial Recognition ECR</div>
        <img :src="require('@/assets/pic/zt8228/icon2.png')" />
        <img :src="require('@/assets/pic/zt8228/icon3.png')" />
        <img :src="require('@/assets/pic/zt8228/icon1.png')" />
      </span>
    </div>
    <div id="z2">
      <label v-if="$store.state.iscn">ZT8629是为了满足最新金融支付需求而设计的新型桌面式双屏刷脸终端。支持银联、微信、支付宝等主流人脸支付系统；集成扫码，银行卡，身份识别等功能模块，适用于商超、酒旅、医保、公安等强身份认证场景。</label>
      <label v-else style="width: 9.5rem">Support facial recognition payment Dual-screen,different display & double touch. Various payment acceptable, including QR, IC card, contactless, etc..</label>
    </div>
    <div id="z3">
      <span v-if="$store.state.iscn">
        <div>大容量&高速</div>
        <label>装载80mm高速热敏打印机，支持自动切纸</label>
        <label>可选58mm高速热敏打印机</label>
      </span>
      <span>
        <h5>HIGH CAPACITY & HIGH SPEED</h5>
        <h5>Built-in 80mm  thermal printer Automatic paper cutting 58mm (optional)</h5>
      </span>
    </div>
    <div id="z4">
      <div>{{$store.state.iscn?'双面一体  高雅大方':'Dual-screen, simple and generous'}}</div>
      <label>{{$store.state.iscn?'超大尺寸双屏，经典倒V设计，双屏异显双触，完美的交互体验':'Big dual-screen, classic inverted V design, smooth lines and clear outlines'}}</label>
    </div>
    <payscene :data="sdata"></payscene>
    <pdspecs :data="$store.state.iscn?spdata:spdata_en"></pdspecs>
  </div>
</template>

<script>
import payscene from '@/components/payscene'
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    payscene,pdspecs
  },
  props: {
    // data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      sdata: {
        data: [
          {
            pic: _this.$store.state.iscn?require('@/assets/pic/zt8629/s1.png'):require('@/assets/pic/zt8629/s1_en.jpg'),
            label: _this.$store.state.iscn?'人脸支付':'Facial'
          },
          {
            pic: require('@/assets/pic/zt8629/s2.png'),
            label: _this.$store.state.iscn?'扫码支付':'QR'
          },
          {
            pic: require('@/assets/pic/zt8629/s3.png'),
            label: _this.$store.state.iscn?'非接触卡支付':'Contactless IC'
          },
        ]
      },
      spdata: {
        file: 'ZT8629',
        data: [
          {label: '处理器', desc: ['ARM八核2.0GHz高速处理器','4核Cortex-A73 + 4核Cortex-A53'],pic: 'cpu.png'},
          {label: '存储器', desc: ['2GB RAM + 16GB ROM','3GB RAM + 32GB ROM（可选）'],pic: 'ram.png'},
          {label: '操作系统', desc: ['Android 9.0','证通安全操作系统（ZOS）'], pic: 'sys.png'},
          {label: '安全', desc: ['支持3DES、AES、RSA、SHA-256、SM2、SM3、SM4等算法'], pic: 'safe.png'},
          {label: '显示屏', desc: ['主屏：15.6英寸1920×1080 LCD','副屏：10.1英寸 800×1280 LCD', '支持双触、异显'], pic: 'disp.png'},
          {label: '读卡器', desc: ['非接IC读卡器×1、MicroSD×1','接触IC读卡器×2(可选）','PSAM读卡器×1（可选）'], pic: 'read.png'},
          {label: '打印机', desc: ['80mm高速热敏打印机，支持自动切纸','可选58mm高速热敏打印机'], pic: 'prt.png'},
          {label: '摄像头（选配）', desc: ['支持3D结构光或者红外双目摄像头','支持活体检测和扫码'], pic: 'face.png'},
          {label: '二代证模块（选配）', desc: ['工作频率：13.56Mhz±7K hz','响应时间：<1s'], pic: '2id.png'},
          {label: '扫码器', desc: ['支持QR Code / EAN-13 / UPC-A / UPC-E / EAN-8 / Code 128 / Code39 / Interleaved 2of5'], pic: 'scan.png'},
          {label: '有线网络', desc: ['10/100Mbps自适应'], pic: 'ethr.png'},
          {label: '移动网络', desc: ['支持 GSM / WCDMA / EVDO / TD-SCDMA /  TDD-LTE / FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['支持IEEE 802.11 a / b / g / n / ac2.4G Hz + 5G Hz'], pic: 'wifi.png'},
          {label: '蓝牙', desc: ['支持蓝牙 4.0及以上','支持BLE'], pic: 'blt.png'},
          {label: '定位', desc: ['内置GPS / 北斗 / Glonass','支持LBS功能','支持AGPS'], pic: 'lbs.png'},
          {label: '密码键盘', desc: ['内置物理密码','支持非接卡读取'], pic: 'keyb.png'},
          {label: '接口', desc: ['USB×4、RS232×1、RJ11×1、RJ45×1、电源口×1'], pic: 'port.png'},
          {label: '适配器', desc: ['输入：AC 100~240V','输出：DC 24V/2.5A'], pic: 'char.png'},
          {label: '尺寸（长×宽×高）', desc: ['295mm×384mm×398mm'], pic: 'size.png'},
          {label: '适用环境', desc: ['工作温度： 0℃～+50℃ ','存储温度：-20℃～+70℃','相对湿度：10%～90% RH (不结露)'], pic: 'env.png'},
        ]
      },
      spdata_en: {
        file: 'ZT8629',
        data: [
          {label: 'Processor', desc: ['Quad core Cortex-A73@2.0Ghz', 'Quad core Cortex-A73@2.0Ghz'],pic: 'cpu.png'},
          {label: 'Memory', desc: ['2GB RAM + 16GB ROM','3GB RAM+32GB ROM( optional)'],pic: 'ram.png'},
          {label: 'Os', desc: ['ZOS based on Android 9.0'], pic: 'sys.png'},
          {label: 'Algorithm', desc: ['3DES、AES、RSA、SHA-256、SM2、SM3、SM4 etc.'], pic: 'safe.png'},
          {label: 'Display', desc: ['Main display:15.6" 1920 ×1080', 'Customer display : 10.1" 800×1280', 'Dual screen, asynchronous display'], pic: 'disp.png'},
          {label: 'Card Reader', desc: ['Contactless x1, MicroSD x1', 'Contact x 2 (optional)', 'PSAM x 1(optional)'], pic: 'read.png'},
          {label: 'Printer', desc: ['Built-in 80mm thermal printer', 'Automatic paper cutting', '58mm(optional)'], pic: 'prt.png'},
          {label: 'Camera (optional)', desc: ['3D Structure Light/ lnfrared binocular camera optional','Live body detection, QR scanning'], pic: 'face.png'},
          {label: 'lD(optional)', desc: ['Frequency:13.56Mhz±7Khz'], pic: '2id.png'},
          {label: 'Scanner', desc: ['QR Code / EAN-13/ UPC-A/ UPC-E / EAN-8 / Code 128/ Code39 / Interleaved 2of5'], pic: 'scan.png'},

          {label: 'Ethernet', desc: ['10/100Mbps'], pic: 'ethr.png'},
          {label: 'Cellular Network', desc: ['GSM / WCDMA / EVDO / TD-SCDMA /  TDD-LTE / FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['IEEE 802.11 a / b / g / n / ac', '2.4G Hz + 5G Hz'], pic: 'wifi.png'},
          {label: 'Bluetooth', desc: ['Bluetooth 2.1/3.0/4.2','BLE'], pic: 'blt.png'},
          {label: 'Location', desc: ['Built-in GPS/Beidou/Glonass','LBS','AGPS'], pic: 'lbs.png'},
          {label: 'Keypad', desc: ['Physical keys x 12','Display x 1'], pic: 'keyb.png'},
          {label: 'Port', desc: ['USB×4、RS232×1、RJ11×1', 'RJ45×1、Power×1'], pic: 'port.png'},
          {label: 'Adapter', desc: ['Input: AC 100-240V','Output: DC 24V/2.5A'], pic: 'char.png'},
          {label: 'Dimension(LxW×H)', desc: ['295mm×384mm×398mm'], pic: 'size.png'},
          {label: 'Environment', desc: ['Working temp: 0℃~+50℃', 'Storage temp: -20℃~+70℃', 'Relative humidity : 10%~90%RH(non-condensing)'], pic: 'env.png'},
        ]
      },
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt8629 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8629/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 4.16rem;
}
#z1_en {
  height: 9rem;
  background-image: url('../../assets/pic/zt8629/bg1_en.jpg');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 4.16rem;
}
#z1_en div {
  margin-top: 1.95rem;
  font-size: .46rem;
  font-weight: bold;
  color: #666666;
  width: 3.8rem;
  margin-bottom: .3rem;
}
#z1_en img {
  height: .42rem;
}
#z1_en img:nth-child(3) {
  margin-left: .32rem;
}
#z1_en img:nth-child(4) {
  display: block;
  margin-top: .25rem;
}
#z1 div {
  margin-top: 2.25rem;
  font-size: .48rem;
  font-weight: bold;
  color: #3D3C3A;
}
#z1 label {
  display: block;
  font-size: .48rem;
  font-weight: bold;
  color: #3D3C3A;
}
#z1 img {
  width: 2.8rem;
  margin-top: .1rem;
}
#z2 {
  height: 1.78rem;
  background: #A4A6AA ;
  text-align: center;
}
#z2 label {
  display: inline-block;
  width: 12.46rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .45rem;
  line-height: .48rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8629/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.47rem;
}
#z3 h5 {
  font-size: .6rem;
  font-weight: bold;
  color: #3D3C3A;
  margin: 2.9rem 0 0 0;
  width: 4.8rem;
}
#z3 h5:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  color: #4D4D4D;
  margin: .1rem 0 0 0;
  width: 5.25rem;
}
#z3 div {
  margin: 2.93rem 0 .29rem 0;
  font-size: .6rem;
  font-weight: bold;
  color: #3D3C3A;
}
#z3 label {
  margin-left: .05rem;
  width: 5.4rem;
  display: block;
  font-size: .24rem;
  font-weight: 400;
  color: #333333;
}

#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8629/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
}
#z4 div {
  margin-top: .74rem;
  margin-bottom: .23rem;
  font-size: .6rem;
  font-weight: bold;
  color: #333333;
}
#z4 label {
  margin-left: .01rem;
  font-size: .24rem;
  font-weight: 400;
  display: block;
  color: #333333;
}

</style>
